var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4362_124721)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 30.5,
    rx: 16.5,
    ry: 10.5,
    fill: "#706F7B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 6,
    fill: "#706F7B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4362_124721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.416cd095a99ba3e32bcaef4e32bcaec7.svg";
export { ForwardRef as ReactComponent };